import React, { useState, useEffect } from 'react';
import { AiFillEye, AiFillGithub, AiFillGitlab } from 'react-icons/ai';
import { FaBitbucket } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { AppWrap, MotionWrap } from '../../wrappers';
import { urlFor, client } from '../../client';
import Modal from '../../components/Modal/Modal';
import './Projects.scss';

const Projects = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  );
  const [projectToggle, setProjectToggle] = useState(false);
  const [activeFilter, setactiveFilter] = useState('Web');
  const [animateCard, setanimateCard] = useState({ y: 0, opacity: 1 });
  const [projects, setProjects] = useState([]);
  const [filterProject, setFilterProject] = useState([]);
  const [videoUrl, setVideoUrl] = useState('');
  const [projectName, setProjectName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');

  const [open, setOpen] = useState(false);

  const handleProjectClick = (videoUrl, projectName, projectDescription) => {
    if (videoUrl) {
      setVideoUrl(videoUrl);
      setProjectName(projectName);
      setProjectDescription(projectDescription);
      setOpen(true);
    }
  };

  const onCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    const query = `*[_type=="projects"] | order(year desc)`;

    client.fetch(query).then((data) => {
      setProjects(data);
      setFilterProject(data.filter((project) => project.tags.includes('Web')));
    });
  }, []);

  const getVideoUrlFromId = (ref) => {
    if (!ref) {
      return;
    }
    const [_file, id, extension] = ref.split('-');
    return `https://cdn.sanity.io/files/${process.env.REACT_APP_SANITY_PROJECT_ID}/production/${id}.${extension}`;
  };

  const handleProjectFilter = (item) => {
    setactiveFilter(item);
    setanimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setanimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterProject(projects);
      } else {
        setFilterProject(
          projects.filter((project) => project.tags.includes(item))
        );
      }
    }, 500);
  };

  return (
    <>
      <Modal
        open={open}
        setOpen={setOpen}
        onCloseModal={onCloseModal}
        title={projectName}
        videoUrl={videoUrl}
        description={projectDescription}
      />
      <h2 className='head-text'>
        {t('portfolio-1')} <span>{t('portfolio-2')}</span> {t('portfolio-3')}
      </h2>

      <div className='app__work-filter'>
        {['Desktop', 'Web', 'Mobile', '3D', 'UI/UX', 'All'].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleProjectFilter(item)}
              className={`app__work-filter-item app__flex p-text ${
                activeFilter === item ? 'item-active' : ''
              }`}
            >
              {t(`${item}`)}
            </div>
          )
        )}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'
      >
        {filterProject.map((project, index) => (
          <div key={index} className='app__work-item app__flex'>
            <div className='app__work-img app__flex'>
              <img src={urlFor(project.imgUrl)} alt={project.name} />
              <motion.div
                whileHover={{ opacity: [0, 1] }}
                whileInView={{
                  opacity: isMobile && projectToggle ? [0, 1] : [1, 0],
                }}
                onClick={(e) => setProjectToggle(!projectToggle)}
                transition={{
                  duration: 0.25,
                  ease: 'easeInOut',
                  staggerChildren: 0.5,
                }}
                className='app__work-hover app__flex'
              >
                <a
                  // href={project.projectLink}
                  target='_blank'
                  rel='noreferrer'
                  onClick={(e) =>
                    handleProjectClick(
                      getVideoUrlFromId(project.videoUrl?.asset?._ref),
                      project.title,
                      project.description
                    )
                  }
                >
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className='app__flex'
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={project.codeLink} target='_blank' rel='noreferrer'>
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className='app__flex'
                  >
                    {project.codeLink.includes('github') ? (
                      <AiFillGithub />
                    ) : project.codeLink.includes('gitlab') ? (
                      <AiFillGitlab />
                    ) : (
                      <FaBitbucket />
                    )}
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className='app__work-content app__flex'>
              <h4 className='bold-text'>{project.title}</h4>
              <p className='p-text' style={{ marginTop: 10 }}>
                {project.description}
              </p>
              <div className='app__work-tag app__flex'>
                <p className='p-text'>{project.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Projects, 'app__works'),
  'projects',
  'app__primarybg'
);
